(function() {
  function initDropdownDetails() {
    document.querySelectorAll('.dropdown-details').forEach((dropdown) => {
      const details = dropdown.querySelector('.dropdown-details__wrapper');
      if (details) {
        // Set initial state
        if (details.hasAttribute('open')) {
          dropdown.classList.add('is-open');
        }
        
        // Handle toggle events
        details.addEventListener('toggle', function() {
          if (details.hasAttribute('open')) {
            dropdown.classList.add('is-open');
          } else {
            dropdown.classList.remove('is-open');
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDropdownDetails);
  } else {
    initDropdownDetails();
  }
})();

